import { Route, Switch, useRouteMatch } from "react-router";

import ActivityCategoryCreate from "./ActivityCategoryCreate";
import ActivityCategoryList from "./ActivityCategoryList";

const ActivityCategories = (props) => {
    let { path } = useRouteMatch();
    return <Switch>
        <Route path={`${path}/create`}><ActivityCategoryCreate {...props} /></Route>
        <Route path={`${path}/:id`}><ActivityCategoryList {...props} /></Route>
        <Route path={`${path}`}><ActivityCategoryList {...props} /></Route>
    </Switch>;
}

export default ActivityCategories;
